// @flow

import {getDenormalizedListFactory} from 'app/utils/redux_v2';
import {convertOptionsToFetchParams} from 'app/notifly/actions';
import {type StoreShapeType} from 'app/reducers/types';

// eslint-disable-next-line no-unused-vars
import type {contentType} from 'app/utils/content-type';

export const denormalizeNotificationsList = getDenormalizedListFactory(
  (state) => state.notifications
);

export const getNotificationsContentTypeMapSelector = (
  state: StoreShapeType,
  contentType: contentType,
  ids: number[]
) => {
  const response = denormalizeNotificationsList(
    state,
    convertOptionsToFetchParams({
      is_all: false,
      target_object_id: ids.join(','),
      target_content_type: contentType,
    })
  );

  if (response.loading === true || response.count === 0) {
    return {};
  }

  return response.results.reduce((map, notification) => {
    let ct = notification.target.content_type;
    if (contentType === 'document') {
      ct = contentType;
    }
    const url = notification.target.url;

    map[ct] = map[ct] || {};
    map[ct][url] = map[ct][url] || [];
    map[ct][url].push(notification);
    return map;
  }, {});
};
